import { WebauthCompletionMode } from '@core/model/domain/webauthCompletionMode';
import { OkVal } from '@core/model/framework/Result/OkResult';
import { Option } from '@core/model/framework/Result/Option';
import { Usecase } from '@core/model/framework/usecase';
import type { BankService, WebauthUrlResult } from '@core/model/service/bankService';
import { SERVICE_ID } from '@di/serviceId';
import { inject, injectable } from 'inversify';
import { ConnectionFormItemDto } from '@core/service/digital-factory/bank/types/dto/connectionFormDto';

export type GetWebauthUrlInput = {
  userToken: string;
  bankId: string;
  form: Option<ConnectionFormItemDto[]>;
  tagging: string | undefined;
  /* Correlation key of the journey, chosen by the origin page (see WaitOnWebauthNotification). */
  journeyKey: string;
  /* Only the relay asks for partner_restore; absent = widget outcome page. */
  mode?: WebauthCompletionMode;
};
export type GetWebauthUrlOutput = Promise<OkVal<WebauthUrlResult>>;

@injectable()
export class GetWebauthUrl implements Usecase<GetWebauthUrlInput, GetWebauthUrlOutput> {
  constructor(
    @inject(SERVICE_ID.bankService)
    private readonly bankService: BankService
  ) {}

  async execute(input: GetWebauthUrlInput): GetWebauthUrlOutput {
    return this.bankService.getWebauthUrl(input);
  }
}
